/*jshint browserify: true */
'use strict';

/**
 * Translate a PDF rectangle into a rectangle for the viewport coordinate system.
 * PDF coordinates put 0,0 at bottom left, viewport coordinates put 0,0 at top right.
 *
 * @input {Object} pdfViewport - Viewport object specifying:
 *   - scale : number indicating scale, 1.0 = 100%
 *   - height : height of the viewport
 *
 * @input {Object} pdfRectangle - An object with the following properties:
 *   - x : X coordinate for the left-most edge of the rectangle.
 *   - y : Y coordinate for the bottom-most edge of the rectangle.
 *   - height : Height of the rectangle.
 *   - width : Width of the rectangle.
 *
 * @return {Object} A rectangle with the following properties:
 *   - x : X coordinate for the left-most edge of the rectangle.
 *   - y : Y coordinate for the top-most edge of the rectangle.
 *   - height : Height of the rectangle.
 *   - width : Width of the rectangle.
 */
function translatePdfRectangleToViewportRectangle(pdfViewport, pdfRectangle) {
    return {
        x: pdfRectangle.x * pdfViewport.scale,
        y: pdfViewport.height - ((pdfRectangle.y + pdfRectangle.height) * pdfViewport.scale),
        height: pdfRectangle.height * pdfViewport.scale,
        width: pdfRectangle.width * pdfViewport.scale
    };
}

module.exports = translatePdfRectangleToViewportRectangle;